module.exports = __webpack_public_path__ + "img/38.72aca4da.jpg";